import { render, staticRenderFns } from "./MailTemplateTips.vue?vue&type=template&id=01e57614&"
import script from "./MailTemplateTips.vue?vue&type=script&lang=js&"
export * from "./MailTemplateTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports